module.exports = __webpack_public_path__ + "assets/Phi.ebe31f9586a59172054949e88acc7d48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x/Phi.png
// module id = 794
// module chunks = 0